// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Y9dTJ","message":"_1utoGf"};